import { render, staticRenderFns } from "./TutorialDialog.vue?vue&type=template&id=0f6ca567&"
import script from "./TutorialDialog.vue?vue&type=script&lang=js&"
export * from "./TutorialDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports